import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { Trans } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { ReactComponent as Logout } from '../../../assets/svg/logout.svg';
import { extractErrorDetail } from '../../../components/common';
import Button from '../../../components/mplat/Button/Button';
import { CheckBox } from '../../../components/mplat/CheckBox';
import Content from '../../../components/mplat/Content';
import ContentRightSideSticky from '../../../components/mplat/ContentRightSideSticky';
import Form from '../../../components/mplat/Form';
import Header1 from '../../../components/mplat/Header1';
import { useUpdateUserProfileAgreementMutation } from '../../../services/users_v1';

function AgreementPD({ profileError }: { profileError: FetchBaseQueryError | SerializedError | undefined }) {
    useEffect(() => { document.title = t('Consent to the processing of personal data'); }, [t]);

    const navigate = useNavigate();

    const [fetchUpdateProfileAgreement] = useUpdateUserProfileAgreementMutation();

    const [agree, setAgree] = useState(false);
    const [error, setError] = useState('');

    return (
        <Content>
            <ContentRightSideSticky>
                <Link to="/logout" title={t('Log out')}>
                    <Logout />
                </Link>
            </ContentRightSideSticky>
            <div className="user-settings">
                <Header1>
                    <Trans>Confirmation</Trans>
                </Header1>

                <Form>
                    <p>
                        <Trans i18nKey="PDConsent">
                            Please <a className="link-accent" href="https://media.msk-ix.ru/download/legal/ru/pd-consent_MSK-IX.pdf" target="_blank" rel="noreferrer">data</a>
                        </Trans>
                    </p>
                    <div className="form__item">
                        <CheckBox value={agree} label={t('Agreed')} onChange={(v) => setAgree(v)} />
                    </div>
                    <div className="user-settings__list-item" style={{ display: 'flex', cursor: 'pointer', alignItems: 'center', justifyContent: 'center' }} >
                        {error && <><br />{error}</>}
                        {profileError && <><br />{extractErrorDetail(profileError)}</>}
                    </div>
                    <div className="form__submit">
                        <Button disabled={!agree} onClick={() => {
                            fetchUpdateProfileAgreement().unwrap().then(() => {
                                navigate('/');
                            }).catch((e) => {
                                setError(e.message);
                            });
                        }}>
                            <Trans>Confirm</Trans>
                        </Button>
                    </div>
                </Form>
            </div>
        </Content>
    )
}


export default AgreementPD;
